import { Link } from '@tanstack/react-router';

import { t } from '@/shared/i18n';

import styles from './NotFoundPage.module.scss';

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>{t.notFound.title}</h1>
      <p className={styles.text}>{t.notFound.text}</p>
      <Link to="/app" className={styles.link}>
        {t.notFound.home}
      </Link>
    </div>
  );
}
